import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export default function AlertModal({ close, isOpen, title, message }) {
  return (
    <Modal size="md" isOpen={isOpen} toggle={close}>
      <ModalHeader toggle={close}>{title}</ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter style={{ display: "block" }}>
        <Button onClick={() => close()} className={"float-start btn-danger"}>
          Ok
        </Button>
      </ModalFooter>
    </Modal>
  );
}
